export type FetchFailureKind = "timeout" | "network";

/**
 * GrailedAPIFetchError is thrown when a request to the Grailed API fails before receiving a
 * response, wrapping the underlying failure as `cause`. `kind` and `url` exist so Sentry can group
 * these by what failed rather than by the shared stack they all come from.
 */
export default class GrailedAPIFetchError extends Error {
  kind: FetchFailureKind;

  url: string;

  cause: unknown;

  constructor(
    message: string,
    {
      kind,
      url,
      cause,
    }: { kind: FetchFailureKind; url: string; cause: unknown },
  ) {
    super(message);
    this.name = "GrailedAPIFetchError";
    this.kind = kind;
    this.url = url;
    this.cause = cause;
  }
}
